import ru from "./ru.ts"
import en from "./en.ts"

export default {
    ru,
    en
}